// extracted by mini-css-extract-plugin
export default {"wrapper":"JardinMelbourne_wrapper__qM0EN"};